import * as React from "react"
const ReferralMember = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="#4D4D4D"
      d="M4.667 6.667H2a.667.667 0 0 0-.667.666v1.334H0V7.333c0-1.102.897-2 2-2h2.667c1.102 0 2 .898 2 2v1.334H5.333V7.333c0-.368-.299-.666-.666-.666ZM1 2.333A2.336 2.336 0 0 1 3.333 0a2.336 2.336 0 0 1 2.334 2.333 2.336 2.336 0 0 1-2.334 2.334A2.336 2.336 0 0 1 1 2.333Zm1.333 0a1.001 1.001 0 0 0 2 0 1.001 1.001 0 0 0-2 0Zm11.667 3h-2.667c-1.102 0-2 .898-2 2v1.334h1.334V7.333c0-.368.299-.666.666-.666H14c.367 0 .667.298.667.666v1.334H16V7.333c0-1.102-.897-2-2-2Zm-3.667-3A2.336 2.336 0 0 1 12.667 0 2.336 2.336 0 0 1 15 2.333a2.336 2.336 0 0 1-2.333 2.334 2.336 2.336 0 0 1-2.334-2.334Zm1.334 0a1.001 1.001 0 0 0 2 0 1.001 1.001 0 0 0-2 0Zm.133 8.033-1.773 1.773.943.942 1.03-1.03V14c0 .368-.3.667-.667.667H4.667A.667.667 0 0 1 4 14v-4H2.667v4c0 1.103.897 2 2 2h6.666c1.103 0 2-.897 2-2v-1.983l1.064 1.064.943-.942-1.773-1.774a1.253 1.253 0 0 0-1.767.001Z"
    />
  </svg>
)
export default ReferralMember
